module.exports = __webpack_public_path__ + "fonts/Nunito-Black.6abf597.ttf";